module.exports = __webpack_public_path__ + "img/right-foot-off.3bd898b8.png";